module.exports = __webpack_public_path__ + "img/022-syria.a971c2a0.svg";